var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTastet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.118,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56",
    fill: "#182b18"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "M69.209 25.049A15.547 15.547 0 0 0 66 20.678c-.6-.62-1.939-1.75-4.778-4.124a50.744 50.744 0 0 1-5.456-5.021 3.035 3.035 0 0 1-.666-1.861 2.283 2.283 0 0 1 .932-1.767 3.6 3.6 0 0 1 2.4-.784q3.007 0 5.909 4.04L69.85 6.3a20.313 20.313 0 0 0-5.734-4.941A12.058 12.058 0 0 0 58.544 0a10.752 10.752 0 0 0-7.649 2.909 9.241 9.241 0 0 0-3.1 6.976c0 1.877 1.276 3.925 2.518 5.811s2.953 4.035 7.212 7.507a28.465 28.465 0 0 1 4.338 4.065 4.448 4.448 0 0 1 .985 2.658 4.266 4.266 0 0 1-1.292 2.963 5.727 5.727 0 0 1-7.883.289c-1.293-1.005-2.364-3.013-4.079-6.341L39.742 5.463s-.294-.641-.54-1.153c-2.13-4.443-6.685-3.909-8.454-.005a21.143 21.143 0 0 0-.464 1.074L16.273 40.3H24l3.18-8.051h17.151l.241.6.049.1a14.138 14.138 0 0 0 4.851 5.928 13.266 13.266 0 0 0 6.009 2.06c3.848.445 9.129-1.288 11.345-3.38a10.439 10.439 0 0 0 3.325-7.943 10.9 10.9 0 0 0-.942-4.565ZM35.163 11.084l5.875 13.91H29.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "M0 1.213h21.6v7.333h-7.119V40.3H6.935V8.546H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M71.958 1.213h21.6v7.333h-7.121V40.3h-7.546V8.546h-6.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M95.93 1.213h21.336v7.281h-13.95v7.068h13.95v7.146h-13.95v10.283h13.95V40.3H95.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M119.515 1.213h21.6v7.333H134V40.3h-7.546V8.546h-6.936Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTastet);
export default __webpack_public_path__ + "static/media/Tastet.a76d1bfdfc3ad4afede7c89ac2fef282.svg";
export { ForwardRef as ReactComponent };